import { useSupportContext } from "@/stores";
import { ImgSrc } from "@/utils";
import { Avatar, Divider, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const ChatHeader: FC = () => {
  const { currentChat } = useSupportContext();
  const navigate = useNavigate();

  if (!currentChat) return;

  return (
    <Stack width={"100%"}>
      <Stack
        direction="row"
        spacing={1}
        p={2}
        onClick={() => navigate(`/users/${currentChat.participant.id}/show`)}
        sx={{ cursor: "pointer" }}
      >
        <Avatar
          style={{ width: 48, height: 48 }}
          src={ImgSrc(
            currentChat.participant.profileImage?.path ?? "",
            128,
            true
          )}
          alt="user-photo"
        >
          D
        </Avatar>
        <Stack>
          <Typography variant="h6">
            {currentChat.participant.isDeleted
              ? "Deleted account"
              : [
                  currentChat.participant.firstName,
                  currentChat.participant.lastName,
                ].join(" ")}
          </Typography>
          <Typography variant="caption" color="textDisabled">
            {currentChat.participant.isDeleted
              ? "Nothing found"
              : currentChat.participant?.visit
              ? `Visiting ${[
                  currentChat.participant.visit.state ??
                    currentChat.participant.visit.city,
                  currentChat.participant.visit.country,
                ].join(", ")}`
              : `In ${currentChat.participant?.locationResidence?.label}`}
          </Typography>
        </Stack>
      </Stack>
      <Divider />
    </Stack>
  );
};

export { ChatHeader };
